export const CACHE_KEYS = {

    Collaborator: "collaborators",
    ThesaurusTerm: "thesaurusTerm",
    numericMuseumItem: "items",
    physicalMuseumItem: "items",
    Item: 'items',
    Authority: 'authorities',
    ConditionReport: 'conditionReports',
    Alias: 'aliases',
}